/**
 * Created by pandemio on 2/6/19.
 */
import React from 'react';
import classNames from 'classnames';
import Dropzone from 'react-dropzone';
import {Translate} from "react-localize-redux";
import Settings from '../../custom-classes/settings';
import LanguageManager from '../../custom-classes/language-manager';
import ModalGeneric from '../modals/modal-generic';
import LoaderFullWindow from '../loader-windows/loader-full-window';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import {faFileUpload} from '@fortawesome/free-solid-svg-icons';

class FileUploader extends React.Component {

    constructor(props) {
        // Super is always called when defining the constructor of a subclass
        // All React component classes that have a constructor, should start it with a super(props) call.
        super(props);

        this.state = {
            message: '',
            error: false,
            subscriptionId: props.subscriptionId,
            session: props.session,
            students: props.students,
            showModal: false,
            propsModal: null
        };

        this.toggleAlertModal = this.toggleAlertModal.bind(this);
    }

    /**
     * Toogles alert modal
     */
    toggleAlertModal(){
        this.setState({showModal: false});
    }

    onDrop = (acceptedFiles, rejectedFiles) => {
        // Only one file at the time
        if(acceptedFiles.length > 1)
        {
           this.setState({
               message: <Translate id="drop-zone.one-file-at-time"  options={{ renderInnerHtml: true }}  />,
               error: true
           });
            return;
        }

        // The CSV files are the only one accepted
        if(!acceptedFiles[0].name.endsWith('.csv'))
        {
            this.setState({
                message: <Translate id="drop-zone.only-csv-allowed"  options={{ renderInnerHtml: true }}  />,
                error: true
            });
            return;
        }

        // Clean
        this.setState({
            message: '',
            error: false
        });

        if(this.state.subscriptionId !== null && !this.state.error)
        {
            this.setState({loading: true});

            const url = Settings.getUploadUsersBulk();
            const form = new FormData();

            for(let i=0; i < acceptedFiles.length; i++)
            {
                let file = acceptedFiles[i];
                form.append('files[]', file);
            }

            form.append("Token", this.state.session);
            form.append("LangCode", LanguageManager.getLanguage());
            form.append("SubscriptionId", this.state.subscriptionId);
            form.append("Student", this.state.students);

            fetch(url, {
                method: 'POST',
                body: form
            }).then(response => {
                this.setState({loading: false});
                return response.json();
            }).then((responseData)=>{
                let data = JSON.parse(responseData);

                let messageStr = '';
                for(let i=0; i < data.Messages.length;i++)
                {
                    messageStr += data.Messages[i] + '<br/>';
                }

                for(let i=0; i < data.UserErrors.length;i++)
                {
                    messageStr +='<br><b>' + data.UserErrors[i].Username + '</b><hr/>';
                    for(let j=0; j < data.UserErrors[i].ErrorDetails.length;j++)
                    {
                        messageStr += data.UserErrors[i].ErrorDetails[j];
                        messageStr += '<br/>';
                    }
                }

                let propsModal = {
                    bodyText: messageStr,
                    visible: true
                };
                this.setState({propsModal: propsModal, showModal: true, loading: false});
            }).catch(()=>{
                this.setState({loading: false});
            });
        }
    };

    render() {
        return (
            <div>
            <Dropzone onDrop={this.onDrop}>
                {({getRootProps, getInputProps, isDragActive}) => {
                    return (
                        <div
                            {...getRootProps()}
                            className={classNames('dropzone', {'dropzone--isActive': isDragActive})}
                        >
                            <input {...getInputProps()} />
                            {
                                <p>
                                    <FontAwesomeIcon className="gray-bright-text" icon={faFileUpload} size='4x'/>
                                </p>
                            }
                            {
                                <br/>
                            }
                            {
                                isDragActive ?
                                    <p><Translate id="drop-zone.drop-file-here"  options={{ renderInnerHtml: true }}  /></p> :
                                    <p><Translate id="drop-zone.instructions"  options={{ renderInnerHtml: true }}  /></p>
                            }
                            {
                                this.state.error && this.state.message !== null && this.state.message !== '' ?
                                    <h3 className="red-text"> {this.state.message} </h3> : ''
                            }
                            {
                                !this.state.error && this.state.message !== null && this.state.message !== '' ?
                                    <h3 className="green-text"> {this.state.message} </h3> : ''
                            }
                        </div>
                    )
                }}
            </Dropzone>
                {this.state.loading ? <LoaderFullWindow/> : null}
                {this.state.showModal ?
                    <ModalGeneric data={this.state.propsModal} updateParent={this.toggleAlertModal}/> : null}
            </div>

        );
    }
}
export default FileUploader;